import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { OcasService } from "../Service/ocas.service";
import { environment } from "../../../../src/environments/environment";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CarrierService } from "app/services/carrier.service";
import { DomSanitizer } from "@angular/platform-browser";
import { UtilityServiceService } from "app/services/utility-service.service";
@Component({
  selector: "app-questionnaire",
  templateUrl: "./questionnaire.component.html",
  styleUrls: ["./questionnaire.component.scss"],
})
export class QuestionnaireComponent implements OnInit {
  @Input() carrierIDInput;
  @Output() saved = new EventEmitter();
  @Output() prevStepEmitter = new EventEmitter<number>();
  questionsData: any;
  questionnairesForm: FormGroup;
  carrier_id;
  responseFileId;
  filebytes: string;
  filetype: any;
  realFile: any;
  getCarrierData;
  message: any;
  isLoading: boolean = false;
  img: any;
  pdfSrc: any;
  showDocument: any = [];
  ocausID;
  questionOcausId;
  showTableData;
  userCreated;
  showTable;
  isSaved = false;
  constructor(
    private _ocasService: OcasService,
    private _fb: FormBuilder,
    private _route: ActivatedRoute,
    private toastService: ToastNotificationService,
    private _carrierService: CarrierService,
    private sanitizer: DomSanitizer,
    private router: Router,
    public utility: UtilityServiceService,
  ) {
    console.log(this.carrierIDInput);

    if (this.carrierIDInput) {
      this.carrier_id = this.carrierIDInput;
    } else {
      this.carrier_id = this._route.snapshot.paramMap.get("id");
    }
    if(this.router.url.includes('carrier/account/add')){
      console.log(this.carrier_id = this.utility.ctrlPages[this.utility.acc.First].carrierId)
      this.carrier_id = this.utility.ctrlPages[this.utility.acc.First].carrierId
    }
  }

  ngOnInit(): void {
    this.getOcausData();
  }

  async getOcausData() {
    this.getQuestions();
    this.createQuestionForm();
    const res = await this._carrierService
      .getCarrierById(this.carrier_id)
      .toPromise();
    this.getCarrierData = [];
    this.getCarrierData = res;

    //fetching already saved data
    const savedQesData: any = await this._ocasService
      .getSavedQuestionnaireById(this.carrier_id)
      .toPromise();
    if (savedQesData) {
      this.showDocument = [];
      savedQesData.forEach((element: any, i) => {
        this.questionsData.findIndex((ele, i) => {
          if (element.Ocas_Type.id === ele.Ocas_Type.id) {
            if (element.Document != null) {
              this.showTableData = element?.Document?.id;
              this.showDocument.push(element);
              this.showDocument.forEach((ele) => {
                this.showTable = ele;
                this.userCreated = ele.id;
              });
            }

            if (element.Carrier_Ocas_Type.note != null) {
              this.questionnairesForm?.controls.questionnaires["controls"][i][
                "controls"
              ].answer.patchValue("YES");
            } else {
              this.questionnairesForm?.controls?.questionnaires["controls"][i][
                "controls"
              ].answer.patchValue("NO");

              if(i===1){
                this.disableQuestion(1,0,'disable');
              }
            }
            this.questionnairesForm?.controls.questionnaires["controls"][i][
              "controls"
            ].note.patchValue(element.Carrier_Ocas_Type.note);
          }
        });
      });
      this.saved.emit(true);
    } else {
      console.log("Data is not save..........");
    }
  }
  getQuestions() {
    this.message = "Please wait....";
    this.isLoading = true;
    this.questionsData = [];
    this._ocasService.getQuestionnaires().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.questionsData = response || [];
        console.log("Collected Question", this.questionsData);
        // @TODO
        this.questionnaires.clear();
        this.addItems(response);
        // if(this.questionsData[i].) {
        //
        // }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  get questionnareForm() {
    return this.questionnairesForm.controls["questionnaires"][
      "controls"
    ] as FormArray;
  }
  createQuestionForm() {
    this.questionnairesForm = this._fb.group({
      questionnaires: new FormArray([]),
    });
  }
  createItem(): FormGroup {
    return this._fb.group({
      answer: new FormControl(null),
      note: new FormControl(""),
      files: new FormControl([]),
    });
  }
  get questionnaires() {
    return this.questionnairesForm.get("questionnaires") as FormArray;
  }
  addItems(questionsData: any): void {
    for (let index = 0; index < questionsData.length; index++) {
      this.questionnaires.push(this.createItem());
    }
  }
  getParticularQuestion(idx: number) {
    return this.questionnaires.controls[idx];
  }
  disableQuestion(startIndex: number, endIndex: number, type: string) {
    if(endIndex ==0) {
      endIndex = this.questionnaires.controls.length - 1;
    }

    if(type==='disable'){
      for (let i = startIndex +1; i <= endIndex; i++) {
        this.questionsData[i].disabled = true;
      }
    }else{
      for (let i = startIndex +1; i <= endIndex; i++) {
        this.questionsData[i].disabled = false;
      }
    }
  }
  getQuestionFiles(idx: number) {
    return this.getParticularQuestion(idx).get("files");
  }
  pushFileIntoQuestion(event, i) {
    const files = this.getQuestionFiles(i);

    let filesAmount = event.target.files.length;

    if (filesAmount > 10) {
      this.toastService.error(`Please select less than 10 file`, "Upload File");
      return;
    }

    for (let findFile = 0; findFile < filesAmount; findFile++) {
      let allowedFileSize =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "MaxUploadMB1"
        );
      let maxAllowedSize = allowedFileSize.Value; //it is in MB

      let document_sizeMB = this.getFileSize(event.target.files[findFile]);

      if (maxAllowedSize <= document_sizeMB) {
        this.toastService.error(
          "Please select image of less than 5 MB",
          "Upload File"
        );
        return;
      }

      let typesOfFile = [];
      if (event.target.files[findFile].type !== "") {
        typesOfFile = this.getFileType(event.target.files[findFile]);
      }

      if (typesOfFile.length <= 0 || typesOfFile[1].toLowerCase() !== "pdf") {
        this.toastService.error(
          "Uploaded file is not a valid. PDF files are allowed",
          "UploadFile"
        );
        return;
      }

      files.value.push(event.target.files[0]);
    }
  }
  removeFileFromQuestion(questionIdx: number, idxToRemove: number) {
    const files = this.getQuestionFiles(questionIdx);
    files.value.splice(idxToRemove, 1);
  }
  @Output() nextStepEmitter = new EventEmitter<number>();
  @Input() isInStepper: boolean = false;
  async questionnairesHandler() {
    const questions = this.questionnairesForm.value.questionnaires;
    const totalAnsweredQuestion = questions.filter(
      (question) => question.answer
    );
    if (this.carrier_id) {
      let count = 0;
      this.isLoading = true;
      for (let [qidx, question] of questions.entries()) {
        // questions.forEach(async (question, qidx) => {
        if (question.answer) {
          // count = count + 1;
          const payload: any = {};
          payload.note = question.note;
          payload.carrier_id = +this.carrier_id;
          payload.ocas_type_id = this.questionsData[qidx].Ocas_Type.id;
          payload.user_created =
            this.questionsData[qidx].Ocas_Type.user_created;
          payload.user_modified =
            this.questionsData[qidx].Ocas_Type.user_modified;
          try {
            count = count + 1;
            await this.saveQuestion(payload, question, count);
          } catch (error) {}
        }else{
          this.next();
        }
      }
      this.isLoading = false;
      this.getOcausData();
      if(this.isSaved == true){
        this.toastService.success('Saved successfully','Success');
        // this.router.navigateByUrl('/carrier/accounts/VCA');
        this.next();
      }

      // );
    }
  }

  async saveQuestion(payload, question, count) {
    const savedQuestion = await this.postQuestionnaires(payload);
    if (savedQuestion && savedQuestion["id"]) {
      this.isSaved = true;
      const files: Array<File> = question.files;
      if (files.length) {
        await this.saveFiles(files, savedQuestion["id"], count);
      }
    }
  }

  async saveFiles(files: Array<File>, fileSaveId, count) {
    const questions = this.questionnairesForm.value.questionnaires;
    const totalAnsweredQuestion = questions.filter(
      (question) => question.answer
    );
    console.log(count, totalAnsweredQuestion.length);
    for (let [index, file] of files.entries()) {
      await this.saveSingleFile(file, fileSaveId);
    }
  }
  async saveSingleFile(file, fileSaveId) {
    const formData: FormData = new FormData();
    formData.append("FileName", "" + new Date().getTime());

    formData.append("TypeOfFile", this.getFileType(file).join("/"));
    formData.append("FileSize", "" + this.getFileSize(file));
    formData.append("carrier_ocas_id", fileSaveId);
    formData.append("Notes", " ");
    formData.append("CarrierID", this.carrier_id);
    formData.append("CarrierName", this.getCarrierData.name);
    formData.append("UserLastName", this.getCarrierData.name);
    formData.append("user_created", this.getCarrierData.user_created);
    formData.append("user_modified", this.getCarrierData.user_modified);
    const filebytes = await this.readFile(file);
    formData.append("File", filebytes as any);
    return this.uploadFile(formData);
  }
  readFile(file) {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = reject;
      fr.onload = () => {
        resolve(fr.result?.toString().split(",")[1]);
        fr.removeEventListener;
      };
      fr.readAsDataURL(file);
    });
  }
  getFileName(file: File) {
    return file.name;
  }
  getFileType(file: File) {
    const typesOfFile = file.type.split("/");
    return typesOfFile;
  }

  getFileSize(file: File) {
    return file.size / 1000000;
  }

  async postQuestionnaires(bodyData: any) {
    return await this._ocasService.postQuestionnaires(bodyData).toPromise();
  }
  uploadFile(formDataValue) {
    return this._ocasService.uploadDocument(formDataValue).toPromise();
  }
  handleNoAnswer(event, idx: number) {
    console.log("Question Index", idx);

    const question = this.getParticularQuestion(idx);
    question.get("files").reset();
    question.get("note").reset();
    if(idx === 0) {
      this.disableQuestion(0, 0, 'disable');
    }
  }
  handleYesAnswer(event, idx: number) {
    const question = this.getParticularQuestion(idx);
    question.get("note").setValue("");
    question.get("files").setValue([]);
    if(idx === 0) {
      this.disableQuestion(0, 0, 'enable');
    }
  }

  viewDoc(documenlink, fileName) {
    const id = documenlink.toString().split("#")[1];
    this.isLoading = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    this._ocasService.downloadpdf(id).subscribe((x: File) => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc = objectURL;
      this.isLoading = false;
    });
  }

  removeUploadedFile(fileId) {
    this.isLoading = true;
    this._ocasService
      .deleteDocumentFormList(fileId.id)
      .subscribe((deleteFile: any) => {
        this.isLoading = false;
        if (deleteFile == true) {
          this.toastService.success("File deleted", "Delete file");
          this.getOcausData();
        } else {
          this.toastService.error("Please try again...", "Delete Document");
        }
      });
  }

  back() {
    this.saved.emit("back");
  }
  
  next() {
    this.saved.emit("next");
  }
  getTotalFiles(data: Array<any>, ocasId) {
    let count = 0;

    data.forEach((doc) => {
      if (doc?.Ocas_Type.id == ocasId) {
        count = count + 1;
      }
    });

    return count;
  }

  nextStep(){
    this.nextStepEmitter.emit(0)
  }

  prevStep(){
    this.prevStepEmitter.emit(0)
  }
}
